import ReadOnlyText from './ReadOnlyText'

export default ReadOnlyText
